// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// producción
// export const environment = {
//   production: true,
//   firebaseConfig : {
//     apiKey: 'AIzaSyAzvJ5tF7OHEBGcTv9oB0B3Q2hlG8o2cVQ',
//     authDomain: 'investigapp-ec690.firebaseapp.com',
//     databaseURL: 'https://investigapp-ec690.firebaseio.com',
//     projectId: 'investigapp-ec690',
//     storageBucket: 'investigapp-ec690.appspot.com',
//     messagingSenderId: '928587026895',
//     appId: '1:928587026895:web:e134d071fd370d9fd7c2ba',
//     measurementId: 'G-214XGZYCLF'
//   }
// };

// desarrollo
export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyAOaH2XK3QfTt7VcB2Ke3sWWVlgjeC-f8A",
    authDomain: "investigar-664cd.firebaseapp.com",
    databaseURL: "https://investigar-664cd.firebaseio.com",
    projectId: "investigar-664cd",
    storageBucket: "investigar-664cd.appspot.com",
    messagingSenderId: "777580032337",
    appId: "1:777580032337:web:b3774044549ca43eb8e370"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.